import React from 'react';
import PropTypes from 'prop-types';
import {filterNodeProperties} from '../../../../utilities/filter-node-properties';
import {withRouter} from 'react-router-dom';


const getDataFromNode = function (node) {
    const keys = ['title', 'src', 'correct', 'x', 'y', 'sprite_hover_index', 'sprite_select_index', 'bgalpha'];
    return filterNodeProperties(node, keys,  { val: node.val });
};

class GraphicAnswerNode extends React.Component {

    constructor(props) {
        super(props);

        const graphicState = props.selected ? 'selected' : '';

        this.state = {
            ...getDataFromNode(props.node),
            height: 0,
            graphicState
        };

    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.selected !== nextProps.selected) {
            this.setState({
                graphicState: nextProps.selected ? 'selected' : ''
            });
        }
    }

    onImgLoad({target: img}) {
        // The image is an sprite image (a single image containing 5 elements).
        this.setState({height: parseInt(img.offsetHeight) / 5});
    }

    onGraphicMouseOver() {
        if (this.state.graphicState !== 'selected') {
            this.setState({
                graphicState: 'hover'
            });
        }
    }

    onGraphicMouseOut() {
        if (this.state.graphicState !== 'selected') {
            this.setState({
                graphicState: ''
            });
        }
    }

    backgroundPosition() {
        // On April 8th according to PITSCO, ALL sprite images, for ALL node types have the following index
        // properties: 1 -base, 2 - base, 3 - active, 4 - hover, 5 - disabled => array equivalent [0,1,2,3,4]
        // IF the sprite images appear in an incorrect order, forward ticket back to Pitsco and notify them that
        // sprite image order is incorrect, and send them index order which would replicate FRE functionality
        // DO NOT use Transformers!
        const {graphicState, height = 0, sprite_hover_index, sprite_select_index} = this.state;

        if (graphicState === 'selected') {
            // graphicState selected corresponds to 3 - Active state
            // left ternary operator because some Modules still use transformers
            const offset = parseInt(height) * (sprite_select_index === undefined ? 2 : sprite_select_index);
            return `0 -${offset}px`;
        } else if (graphicState === 'hover') {
            // graphicState hover corresponds to 4 - hover (mouseOver) state
            const offset = parseInt(height) * (sprite_hover_index === undefined ? 3 : sprite_hover_index);
            return `0 -${offset}px`;
        } else if (graphicState === 'disabled') {
            // graphicState disabled corresponds to 5 - Disabled state
            const offset = parseInt(height) * (sprite_hover_index === undefined ? 4 : sprite_hover_index);
            return `0 -${offset}px`;
        } else {
            // BASE state corresponds to 1 - base and 2 - base
            return 'initial';
        }
    }

    render() {
        const {moduleURL = '', zIndex} = this.props;
        const {src = '', x = 0, y = 0, height = 0, bgalpha = ''} = this.state;
        const divStyle = {
            top: `${y}px`,
            left: `${x}px`,
            height: height,
            cursor: 'pointer',
            background: `url(${moduleURL}/media/${src}) no-repeat`,
            backgroundPosition: this.backgroundPosition(),
            zIndex: zIndex,
        };

        if (bgalpha) {
            // if we need to set opacity, we divide the XML value by 100
            divStyle.opacity = bgalpha === '0' ? 0 : parseInt(bgalpha) / 100;
        }

        return (
            <div className="node" style={divStyle} onMouseOver={this.onGraphicMouseOver.bind(this)}
                 onMouseOut={this.onGraphicMouseOut.bind(this)} onClick={this.props.onGraphicSelected}>
                {/* This non-visible image element is used to get the height of the image. */}
                <img className="visibility-hidden" onLoad={this.onImgLoad.bind(this)}
                     src={`${moduleURL}/media/${src}`}/>
            </div>
        );
    }
}

GraphicAnswerNode.propTypes = {
    node: PropTypes.object.isRequired,
    selected: PropTypes.bool.isRequired
};

export default withRouter(GraphicAnswerNode);



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/graphic-answer-node.js